import {EmailPromotionType} from '@optimaxdev/analytics/desktop/types';

import {PAYMENTS} from './paymentStep';

export enum STEPS {
    DELIVERY_STEP = 'deliveryStep',
    PAYMENT_STEP = 'paymentStep',
    REVIEW_STEP = 'reviewStep',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    DEFAULT_STEP = 'deliveryStep',
}

export const PLA = 'PLA';

export const CURRENT_STEP_KEY = 'CURRENT_STEP_KEY';

export const INITIAL_FORM_VALUES = {
    address: {error: false, success: false, value: ''},
    city: {error: false, success: false, value: ''},
    country: {error: false, success: false, value: 'US'},
    email: {error: false, success: false, value: ''},
    firstName: {error: false, success: false, value: ''},
    lastName: {error: false, success: false, value: ''},
    other: {error: false, success: false, value: ''},
    phone: {error: false, success: false, value: ''},
    postal: {error: false, success: false, value: ''},
    regionID: {error: false, success: false, value: ''},
    state: {error: false, success: false, value: '0'},
};

export const PAYMENT_CODE_MESSAGE: Partial<Record<PAYMENTS, string>> = {
    [PAYMENTS.METHOD_AMAZON_V2]: 'Amazon pay',
    [PAYMENTS.METHOD_APPLE_PAY]: 'Apple pay',
    [PAYMENTS.METHOD_CASH_ON_DELIVERY]: 'Cash On Delivery',
    [PAYMENTS.METHOD_CREDIT_CARD]: 'Credit Card',
    [PAYMENTS.METHOD_CREDIT_CARD_FSA]: 'FSA/HSA',
    [PAYMENTS.METHOD_DEFAULT]: 'Credit Card',
    [PAYMENTS.METHOD_FREE]: 'Free',
    [PAYMENTS.METHOD_GIFT]: 'Gift Card',
    [PAYMENTS.METHOD_GOOGLE_PAY]: 'Google Pay',
    [PAYMENTS.METHOD_KLARNA]: 'Klarna',
    [PAYMENTS.METHOD_PAYPAL_V3]: 'PayPal',
    [PAYMENTS.METHOD_PRIMER]: 'Primer Credit Card',
    [PAYMENTS.METHOD_PRIMER_APPLE_PAY]: 'Primer Apple Pay',
    [PAYMENTS.METHOD_PRIMER_FSA]: 'FSA/HSA',
    [PAYMENTS.METHOD_PRIMER_GOOGLE_PAY]: 'Primer Google Pay',
    [PAYMENTS.METHOD_PRIMER_KLARNA]: 'Primer Klarna',
    [PAYMENTS.METHOD_PRIMER_PAYPAL]: 'Primer Paypal',
    [PAYMENTS.METHOD_RECURLY]: 'Recurly (Credit Card)',
    [PAYMENTS.METHOD_RECURLY_PAYPAL]: 'Recurly (PayPal)',
    [PAYMENTS.METHOD_VENMO]: 'Venmo',
};

export const CHECKBOX_STATUS: {[key: string]: EmailPromotionType} = {
    AUTO_MARKED: 'Auto Marked',
    CHECKED: 'Marked',
    UNCHECKED: 'Unmarked',
    UNSEEN: 'Not showed',
};

export const SUBSCRIPTION_LOCATION: {[key: string]: string} = {
    checkout: 'Checkout',
    footer: 'Footer',
    oneTap: 'Google One Tap',
    signup: 'Create Account',
};

export const PATH_TO_CART = '/checkout/cart';

export const PAYPAL_ORDER_SUCCESS_STATUS = 'success';

export const SUBSCRIBER_BY_PHONE = 'SUBSCRIBER_BY_PHONE';

export const SUBSCRIBER = 'SUBSCRIBER';

export const LOGIN_METHOD = 'loginMethod';
